// import React, { useState, useEffect } from 'react';
// import { Send, Bell, History, Search, Image, Users, Loader2, RefreshCw, Plus, X, ExternalLink } from 'lucide-react';

// export default function PushNotifications() {
//   const sessionUser = JSON.parse(sessionStorage.getItem('userSession')) || { name: "Admin" };

//   const [logsHistory, setLogsHistory] = useState([]);
//   const [tableLoading, setTableLoading] = useState(false);
//   const [dispatchLoading, setDispatchLoading] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');

//   // Clean, Explicit Structural States
//   const [audienceScope, setAudienceScope] = useState('all');
//   const [targetValue, setTargetValue] = useState('');
//   const [title, setTitle] = useState('');
//   const [body, setBody] = useState('');
//   const [selectedFile, setSelectedFile] = useState(null);

//   useEffect(() => {
//     fetchLogsHistory();
//   }, []);

//   const fetchLogsHistory = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/api/notification/history');
//       const result = await res.json();
//       if (result.success) setLogsHistory(result.data);
//     } catch (err) { console.error(err); }
//     finally { setTableLoading(false); }
//   };

//   const handleDispatchSubmit = async (e) => {
//     e.preventDefault();
//     setDispatchLoading(true);

//     // Using native FormData instance constructor to package structural multi-part binary file uploads
//     const formData = new FormData();
//     formData.append('audience_scope', audienceScope);
//     formData.append('target_value', audienceScope === 'all' ? 'Broadcast All' : targetValue);
//     formData.append('title', title);
//     formData.append('body', body);
//     formData.append('dispatched_by_name', sessionUser.name);
//     if (selectedFile) {
//       formData.append('banner_image', selectedFile);
//     }

//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/api/notification/dispatch', {
//         method: 'POST',
//         body: formData // Note: Content-Type headers are automatically managed by the browser when passing FormData
//       });
//       const data = await res.json();
//       alert(data.message);
//       if (data.success) {
//         // Clear variables back to native configurations
//         setAudienceScope('all');
//         setTargetValue('');
//         setTitle('');
//         setBody('');
//         setSelectedFile(null);
//         setIsModalOpen(false);
//         fetchLogsHistory();
//       }
//     } catch (err) { console.error(err); }
//     finally { setDispatchLoading(false); }
//   };

//   const filteredLogs = logsHistory.filter(log => 
//     log.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     log.body.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div style={styles.container}>
      
//       {/* STEP 1: TOP DYNAMIC CONTROLS ACTIONS PANELS ROW */}
//       <div style={styles.topActionBar}>
//         <div style={styles.paneTitleGroup}>
//           <h2 style={styles.mainTitle}>Push Notifications</h2>
//           <p style={styles.mainSubtitle}>Send updates and fee reminders directly to students</p>
//         </div>
//         <button onClick={() => setIsModalOpen(true)} style={styles.addBtn}>
//           <Plus size={15} style={{ marginRight: '6px' }} /> Send Notification
//         </button>
//       </div>

//       {/* STEP 2: SEARCH STRIP FILTERS */}
//       <div style={styles.filterControlPanel}>
//         <div style={styles.searchWrapper}>
//           <Search size={16} style={styles.searchIcon} />
//           <input type="text" placeholder="Search logs history..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={styles.tableSearchInput} />
//         </div>
//         <button onClick={fetchLogsHistory} style={styles.refreshBtn} title="Refresh Table">
//           <RefreshCw size={13} style={{ marginRight: '4px' }} /> Refresh
//         </button>
//       </div>

//       {/* STEP 3: MASTER CLEAN REGISTRY DATA TABLE */}
//       <div style={styles.tableCard}>
//         {tableLoading ? (
//           <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#1c6ec9" /></div>
//         ) : (
//           <div style={{ overflowX: 'auto', width: '100%' }}>
//             <table style={styles.dataTable}>
//               <thead>
//                 <tr>
//                   <th style={styles.tableTh}>Date Sent</th>
//                   <th style={styles.tableTh}>Message Details</th>
//                   <th style={styles.tableTh}>Target Audience</th>
//                   <th style={styles.tableTh}>Delivery Count</th>
//                   <th style={styles.tableTh}>Sent By</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredLogs.length === 0 ? (
//                   <tr><td colSpan="5" style={styles.noDataTd}>No notification logs found.</td></tr>
//                 ) : (
//                   filteredLogs.map((log) => (
//                     <tr key={log.id} style={styles.tableTr}>
//                       <td style={{ ...styles.tableTd, fontSize: '12.5px' }}>
//                         {new Date(log.sent_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
//                       </td>
//                       <td style={{ ...styles.tableTd, whiteSpace: 'normal', minWidth: '220px' }}>
//                         <strong style={{ color: '#0f172a', display: 'block', fontSize: '13.5px' }}>{log.title}</strong>
//                         <div style={{ fontSize: '12.5px', color: '#64748b', marginTop: '3px' }}>{log.body}</div>
//                         {log.image_url && (
//                           <a href={log.image_url} target="_blank" rel="noreferrer" style={styles.imageLinkAnchor}>
//                             <Image size={11} style={{ marginRight: '3px' }} /> View Image Graphic <ExternalLink size={10} style={{ marginLeft: '3px' }} />
//                           </a>
//                         )}
//                       </td>
//                       <td style={styles.tableTd}>
//                         <span style={styles.scopeLabel}>{log.audience_scope.toUpperCase()}</span>
//                         <span style={{ fontSize: '11.5px', color: '#334155', display: 'block', marginTop: '4px', fontWeight: '600' }}>{log.target_value}</span>
//                       </td>
//                       <td style={styles.tableTd}>
//                         <span style={styles.countBadge}><Users size={11} /> {log.tokens_targeted_count} devices</span>
//                       </td>
//                       <td style={{ ...styles.tableTd, fontWeight: '500' }}>{log.dispatched_by_name}</td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* STEP 4: CLEAN DISPATCH CREATION POPUP FORM MODAL */}
//       {isModalOpen && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modalWrapperCard}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Compose Notification</h3>
//               <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
//             </div>
            
//             <form onSubmit={handleDispatchSubmit} style={styles.composerForm}>
//               <div style={styles.fieldContainer}>
//                 <label style={styles.fieldLabel}>Audience Group</label>
//                 <select value={audienceScope} onChange={(e) => { setAudienceScope(e.target.value); setTargetValue(''); }} style={styles.formSelect}>
//                   <option value="all">All Students</option>
//                   <option value="course">By Course</option>
//                   <option value="semester">By Semester</option>
//                   <option value="individual">Individual Student</option>
//                 </select>
//               </div>

//               {/* BATCH DYNAMIC FIELD FILTERS SELECTIONS */}
//               {audienceScope !== 'all' && (
//                 <div style={styles.fieldContainer}>
//                   <label style={styles.fieldLabel}>Target Value</label>
//                   {audienceScope === 'course' ? (
//                     <select required value={targetValue} onChange={(e) => setTargetValue(e.target.value)} style={styles.formSelect}>
//                       <option value="">-- Choose Course --</option>
//                       <option>React FullStack</option><option>Data Science & AI</option><option>B.B.A.</option><option>M.C.A.</option>
//                     </select>
//                   ) : audienceScope === 'semester' ? (
//                     <select required value={targetValue} onChange={(e) => setTargetValue(e.target.value)} style={styles.formSelect}>
//                       <option value="">-- Choose Semester --</option>
//                       <option>Semester 1</option><option>Semester 2</option><option>Semester 3</option><option>Semester 4</option>
//                     </select>
//                   ) : (
//                     <input type="text" required placeholder="Enter Student Admission Number" value={targetValue} onChange={(e) => setTargetValue(e.target.value)} style={styles.formInput} />
//                   )}
//                 </div>
//               )}

//               <div style={styles.fieldContainer}>
//                 <label style={styles.fieldLabel}>Title</label>
//                 <input type="text" required placeholder="e.g., Exam Schedule Alert" value={title} onChange={(e) => setTitle(e.target.value)} style={styles.formInput} />
//               </div>

//               <div style={styles.fieldContainer}>
//                 <label style={styles.fieldLabel}>Message Content</label>
//                 <textarea required rows="4" placeholder="Enter notification message text here..." value={body} onChange={(e) => setBody(e.target.value)} style={styles.formTextArea} />
//               </div>

//               <div style={styles.fieldContainer}>
//                 <label style={styles.fieldLabel}>Upload Banner Graphic Image</label>
//                 <input 
//                   type="file" 
//                   accept="image/*" 
//                   onChange={(e) => setSelectedFile(e.target.files[0])} 
//                   style={styles.formFileInput} 
//                 />
//               </div>

//               <div style={styles.formActionDock}>
//                 <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//                 <button type="submit" disabled={dispatchLoading} style={styles.formSaveBtn}>
//                   {dispatchLoading ? <Loader2 size={14} style={{ animation: 'spin 1s linear infinite', marginRight: '4px' }} /> : <Send size={13} style={{ marginRight: '4px' }} />}
//                   Send Broadcast
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // FORMATTING ARCHITECTURE STYLE SHEET MATRIX RULES
// const styles = {
//   container: { width: '100%', boxSizing: 'border-box' },
//   topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
//   paneTitleGroup: { display: 'flex', flexDirection: 'column' },
//   mainTitle: { margin: 0, fontSize: '20px', fontWeight: '700', color: '#0f172a' },
//   mainSubtitle: { margin: '2px 0 0 0', fontSize: '13px', color: '#64748b' },
//   addBtn: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', border: 'none', borderRadius: '10px', color: '#ffffff', padding: '10px 18px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', boxShadow: '0 4px 12px rgba(28, 110, 201, 0.15)' },
//   filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' },
//   searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '320px', width: '100%' },
//   searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
//   tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
//   refreshBtn: { background: '#ffffff', border: '1px solid #cbd5e1', padding: '8px 14px', color: '#475569', borderRadius: '8px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', fontSize: '13px', fontWeight: '500' },
//   tableCard: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '14px', width: '100%', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.01)' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
//   tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
//   tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
//   tableTd: { padding: '14px', color: '#475569', fontSize: '13.5px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
//   noDataTd: { padding: '36px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px' },
//   imageLinkAnchor: { display: 'inline-flex', alignItems: 'center', marginTop: '5px', background: '#eff6ff', padding: '4px 8px', borderRadius: '5px', fontSize: '11px', color: '#1c6ec9', fontWeight: '600', border: '1px solid #bfdbfe', textDecoration: 'none', transition: 'all 0.2s' },
//   scopeLabel: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '2px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '700', letterSpacing: '0.3px', display: 'inline-block' },
//   countBadge: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '4px 8px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '4px' },
//   modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
//   modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '480px', maxHeight: '90vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
//   modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   composerForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px' },
//   fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
//   fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
//   formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
//   formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
//   formFileInput: { fontSize: '12px', color: '#475569', padding: '8px 0' },
//   formTextArea: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' },
//   formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
//   formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
//   formSaveBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '13px', display: 'inline-flex', alignItems: 'center' }
// };

import React, { useState, useEffect } from 'react';
import { Send, Bell, History, Search, Image, Users, Loader2, RefreshCw, Plus, X, ExternalLink, Trash2, Edit3 } from 'lucide-react';

export default function PushNotifications() {
  const sessionUser = JSON.parse(sessionStorage.getItem('userSession')) || { name: "Admin" };

  const [logsHistory, setLogsHistory] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [dispatchLoading, setDispatchLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // 📝 CRUD Context Control Flags
  const [editingId, setEditingId] = useState(null);

  // Pagination Parameters
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;


  // ➕ Dynamic Courses State
  const [coursesList, setCoursesList] = useState([]);
  // Form Field Bound Variables
  const [audienceScope, setAudienceScope] = useState('all');
  const [targetValue, setTargetValue] = useState('');
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    fetchLogsHistory();
  }, []);


  // ➕ Fetch dynamic courses list from backend API
  useEffect(() => {
    const fetchCoursesList = async () => {
      try {
        const res = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
        const data = await res.json();
        if (data.success && data.data.length > 0) {
          setCoursesList(data.data);
        }
      } catch (err) {
        console.error("Failed to fetch courses for notification targeting:", err);
      }
    };
    fetchCoursesList();
  }, []);

  const fetchLogsHistory = async () => {
    setTableLoading(true);
    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/notification/history');
      const result = await res.json();
      if (result.success) setLogsHistory(result.data);
    } catch (err) { console.error(err); }
    finally { setTableLoading(false); }
  };

  const handleOpenAddModal = () => {
    setEditingId(null);
    setAudienceScope('all');
    setTargetValue('');
    setTitle('');
    setBody('');
    setSelectedFile(null);
    setIsModalOpen(true);
  };

  const handleOpenEditModal = (log) => {
    setEditingId(log.id);
    setAudienceScope(log.audience_scope);
    setTargetValue(log.target_value === 'Broadcast All' ? '' : log.target_value);
    setTitle(log.title);
    setBody(log.body);
    setSelectedFile(null); // Leave file unselected unless they upload a correction file
    setIsModalOpen(true);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setDispatchLoading(true);

    const formData = new FormData();
    formData.append('audience_scope', audienceScope);
    formData.append('target_value', audienceScope === 'all' ? 'Broadcast All' : targetValue);
    formData.append('title', title);
    formData.append('body', body);
    formData.append('dispatched_by_name', sessionUser.name);
    if (selectedFile) {
      formData.append('banner_image', selectedFile);
    }

    const endpoint = editingId ? `update-log/${editingId}` : 'dispatch';
    const method = editingId ? 'PUT' : 'POST';

    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/notification/${endpoint}`, {
        method: method,
        body: formData
      });
      const data = await res.json();
      alert(data.message);
      if (data.success) {
        setIsModalOpen(false);
        fetchLogsHistory();
      }
    } catch (err) { console.error(err); }
    finally { setDispatchLoading(false); }
  };

  const handleDeleteLog = async (id) => {
    if (!window.confirm("Are you sure you want to remove this notice log record?")) return;
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/notification/delete-log/${id}`, {
        method: 'PUT'
      });
      if ((await res.json()).success) {
        fetchLogsHistory();
      }
    } catch (err) { console.error(err); }
  };

  const filteredLogs = logsHistory.filter(log => 
    log.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    log.body.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Compute Pagination Ranges Slices Safely
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLogs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredLogs.length / itemsPerPage);

  return (
    <div style={styles.container}>
      
      {/* STEP 1: TOP CONTROL BAR SURFACE */}
      <div style={styles.topActionBar}>
        <div style={styles.paneTitleGroup}>
          <h2 style={styles.mainTitle}>Push Notifications</h2>
          <p style={styles.mainSubtitle}>Send updates and fee reminders directly to students</p>
        </div>
        <button onClick={handleOpenAddModal} style={styles.addBtn}>
          <Plus size={15} style={{ marginRight: '6px' }} /> Send Notification
        </button>
      </div>

      {/* STEP 2: SEARCH STRIP FILTERS */}
      <div style={styles.filterControlPanel}>
        <div style={styles.searchWrapper}>
          <Search size={16} style={styles.searchIcon} />
          <input 
            type="text" 
            placeholder="Search logs history..." 
            value={searchTerm} 
            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} 
            style={styles.tableSearchInput} 
          />
        </div>
        <button onClick={fetchLogsHistory} style={styles.refreshBtn} title="Refresh Table">
          <RefreshCw size={13} style={{ marginRight: '4px' }} /> Refresh
        </button>
      </div>

      {/* STEP 3: DATA REGISTRY GRID */}
      <div style={styles.tableCard}>
        {tableLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#1c6ec9" /></div>
        ) : (
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <table style={styles.dataTable}>
              <thead>
                <tr>
                  <th style={styles.tableTh}>Date Sent</th>
                  <th style={styles.tableTh}>Message Details</th>
                  <th style={styles.tableTh}>Target Audience</th>
                  <th style={styles.tableTh}>Delivery Count</th>
                  <th style={styles.tableTh}>Sent By</th>
                  <th style={styles.tableTh}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr><td colSpan="6" style={styles.noDataTd}>No notification logs found.</td></tr>
                ) : (
                  currentItems.map((log) => (
                    <tr key={log.id} style={styles.tableTr}>
                      <td style={{ ...styles.tableTd, fontSize: '12.5px' }}>
                        {new Date(log.sent_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                      </td>
                      <td style={{ ...styles.tableTd, whiteSpace: 'normal', minWidth: '220px' }}>
                        <strong style={{ color: '#0f172a', display: 'block', fontSize: '13.5px' }}>{log.title}</strong>
                        <div style={{ fontSize: '12.5px', color: '#64748b', marginTop: '3px' }}>{log.body}</div>
                        {log.image_url && (
                          <a href={log.image_url} target="_blank" rel="noreferrer" style={styles.imageLinkAnchor}>
                            <Image size={11} style={{ marginRight: '3px' }} /> View Image Graphic <ExternalLink size={10} style={{ marginLeft: '3px' }} />
                          </a>
                        )}
                      </td>
                      <td style={styles.tableTd}>
                        <span style={styles.scopeLabel}>{log.audience_scope.toUpperCase()}</span>
                        <span style={{ fontSize: '11.5px', color: '#334155', display: 'block', marginTop: '4px', fontWeight: '600' }}>{log.target_value}</span>
                      </td>
                      <td style={styles.tableTd}>
                        <span style={styles.countBadge}><Users size={11} /> {log.tokens_targeted_count} devices</span>
                      </td>
                      <td style={{ ...styles.tableTd, fontWeight: '500' }}>{log.dispatched_by_name}</td>
                      <td style={styles.tableTd}>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button onClick={() => handleOpenEditModal(log)} style={styles.editRowBtn} title="Correct Mistake Entry">
                            <Edit3 size={13} />
                          </button>
                          <button onClick={() => handleDeleteLog(log.id)} style={styles.deleteRowBtn} title="Remove Record Log">
                            <Trash2 size={13} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION NAVIGATION TOOLBAR SURFACE */}
      {filteredLogs.length > 0 && (
        <div style={styles.paginationDock}>
          <button 
            disabled={currentPage === 1} 
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Previous
          </button>
          <span style={styles.pageIndicator}>
            Page <strong>{currentPage}</strong> of {totalPages || 1}
          </span>
          <button 
            disabled={currentPage === totalPages || totalPages === 0} 
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Next
          </button>
        </div>
      )}

      {/* STEP 4: COMPOSER POPUP MANAGEMENT FORM MODAL CONTAINER */}
      {isModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>
                {editingId ? 'Edit Published Notification' : 'Compose Notification'}
              </h3>
              <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
            </div>
            
            <form onSubmit={handleFormSubmit} style={styles.composerForm}>
              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Audience Group</label>
                <select value={audienceScope} onChange={(e) => { setAudienceScope(e.target.value); setTargetValue(''); }} style={styles.formSelect}>
                  <option value="all">All Students</option>
                  <option value="course">By Course</option>
           
                  <option value="individual">Individual Student</option>
                </select>
              </div>

              {audienceScope !== 'all' && (
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Target Filter Match Value</label>
                 {audienceScope === 'course' ? (
  <select required value={targetValue} onChange={(e) => setTargetValue(e.target.value)} style={styles.formSelect}>
    <option value="">-- Choose Course --</option>
    {coursesList.length === 0 ? (
      <option value="" disabled>Loading courses...</option>
    ) : (
      coursesList.map((course) => (
        <option key={course.id} value={course.course_name.trim()}>
          {course.course_name.trim()}
        </option>
      ))
    )}
  </select>
) : audienceScope === 'semester' ? (
                    <select required value={targetValue} onChange={(e) => setTargetValue(e.target.value)} style={styles.formSelect}>
                      <option value="">-- Choose Semester --</option>
                      <option>Semester 1</option><option>Semester 2</option><option>Semester 3</option><option>Semester 4</option>
                    </select>
                  ) : (
                    <input type="text" required placeholder="Enter Student Admission Number" value={targetValue} onChange={(e) => setTargetValue(e.target.value)} style={styles.formInput} />
                  )}
                </div>
              )}

              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Heading Title</label>
                <input type="text" required placeholder="e.g., Exam Schedule Alert" value={title} onChange={(e) => setTitle(e.target.value)} style={styles.formInput} />
              </div>

              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Message Content Body</label>
                <textarea required rows="4" placeholder="Enter notification message content text details here..." value={body} onChange={(e) => setBody(e.target.value)} style={styles.formTextArea} />
              </div>

              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Upload Banner Graphic Image {editingId && <span style={{ color: '#64748b' }}>(Leave empty to keep current)</span>}</label>
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={(e) => setSelectedFile(e.target.files[0])} 
                  style={styles.formFileInput} 
                />
              </div>

              <div style={styles.formActionDock}>
                <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
                <button type="submit" disabled={dispatchLoading} style={styles.formSaveBtn}>
                  {dispatchLoading ? <Loader2 size={14} style={{ animation: 'spin 1s linear infinite', marginRight: '4px' }} /> : <Send size={13} style={{ marginRight: '4px' }} />}
                  {editingId ? 'Save Changes' : 'Send Broadcast'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

// PREMIUM BRAND MATRIX RULES SHEETS STYLE OBJECTS
const styles = {
  container: { width: '100%', boxSizing: 'border-box' },
  topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
  paneTitleGroup: { display: 'flex', flexDirection: 'column' },
  mainTitle: { margin: 0, fontSize: '20px', fontWeight: '700', color: '#0f172a' },
  mainSubtitle: { margin: '2px 0 0 0', fontSize: '13px', color: '#64748b' },
  addBtn: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', border: 'none', borderRadius: '10px', color: '#ffffff', padding: '10px 18px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', boxShadow: '0 4px 12px rgba(28, 110, 201, 0.15)' },
  filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' },
  searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '320px', width: '100%' },
  searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
  tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
  refreshBtn: { background: '#ffffff', border: '1px solid #cbd5e1', padding: '8px 14px', color: '#475569', borderRadius: '8px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', fontSize: '13px', fontWeight: '500' },
  tableCard: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '14px', width: '100%', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.01)' },
  dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
  tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
  tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
  tableTd: { padding: '14px', color: '#475569', fontSize: '13.5px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
  noDataTd: { padding: '36px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px' },
  imageLinkAnchor: { display: 'inline-flex', alignItems: 'center', marginTop: '5px', background: '#eff6ff', padding: '4px 8px', borderRadius: '5px', fontSize: '11px', color: '#1c6ec9', fontWeight: '600', border: '1px solid #bfdbfe', textDecoration: 'none', transition: 'all 0.2s' },
  scopeLabel: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '2px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '700', letterSpacing: '0.3px', display: 'inline-block' },
  countBadge: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '4px 8px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '4px' },
  editRowBtn: { background: '#ffffff', border: '1px solid #cbd5e1', color: '#166534', padding: '6px', borderRadius: '6px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' },
  deleteRowBtn: { background: '#ffffff', border: '1px solid #fecaca', color: '#b91c1c', padding: '6px', borderRadius: '6px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '480px', maxHeight: '90vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
  modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
  composerForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px' },
  fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
  fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
  formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
  formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
  formFileInput: { fontSize: '12px', color: '#475569', padding: '8px 0' },
  formTextArea: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' },
  formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
  formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  formSaveBtn: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '13px', display: 'inline-flex', alignItems: 'center' },
  paginationDock: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #edf2f7' },
  pageIndicator: { fontSize: '13px', color: '#475569' },
  pageBtn: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '6px 14px', color: '#334155', fontSize: '12.5px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s' },
  pageBtnDisabled: { background: '#f8fafc', color: '#94a3b8', cursor: 'not-allowed', borderColor: '#e2e8f0' }
};